<template>
  <div>
    <CustomCollaspe
      v-for="genresItem in genresList"
      :key="genresItem.traitType"
      :collapse-id="genresItem.traitType"
      :collapse-header="transformTraitType(genresItem.traitType)"
      :show-btn-clear="true"
      @clear="clearProperty(genresItem.traitType)"
      class="filter-collapse"
    >
      <StarFilter
        v-if="genresItem.traitType === 'stars'"
        :ref="genresItem.traitType"
        @filtered-star="handleSearchRadio"
      />
      <CustomRadio
        v-else-if="genresItem.displayType === 'radio'"
        :ref="genresItem.traitType"
        class="checkbox-grid traittype"
        :options="genresItem.value"
        :trait-type="genresItem.traitType"
        @selectRadio="handleSearchRadio"
      />
      <CustomRange
        v-else-if="genresItem.displayType === 'range'"
        :ref="genresItem.traitType"
        :traitType="genresItem.traitType"
        :minValue="
          genresItem.traitType === 'level'
            ? genresItem.value.minimum + 1
            : genresItem.value.minimum
        "
        :maxValue="
          genresItem.traitType === 'level'
            ? genresItem.value.maximum + 1
            : genresItem.value.maximum
        "
        @handleSearch="handleSearchRange"
      />
    </CustomCollaspe>
  </div>
</template>

<script>
import CustomCollaspe from '@/components/BaseComponents/CustomCollapse.vue';
import CustomRadio from '@/components/BaseComponents/CustomRadio.vue';
import CustomRange from '@/components/BaseComponents/CustomRange.vue';
import StarFilter from '@/components/BaseComponents/StarFilter.vue';
import rf from '@/requests/RequestFactory';
import { cleanObject } from '@/helpers/index';
import { transformTraitType } from '@/helpers/utils';

export default {
  components: {
    CustomCollaspe,
    CustomRadio,
    CustomRange,
    StarFilter
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    collectionAddress: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      genresList: [],
      attributes: []
    };
  },
  watch: {
    collectionAddress() {
      if (this.collectionAddress) {
        this.getGenres();
      }
    }
  },
  created() {
    if (this.collectionAddress) {
      this.getGenres();
    }
  },
  methods: {
    cleanObject,
    transformTraitType,
    async getGenres() {
      this.genresList = [];
      const res = await rf
        .getRequest('GameMarketplaceRequest')
        .getGenres(this.collectionAddress);
      if (res) {
        this.genresList = res;
      }
    },
    handleSearchRadio(traitType, data) {
      if (data === '') {
        if (traitType === 'stars') {
          this.$emit('update:data', {
            ...this.data,
            stars: data
          });
        }
        return;
      }
      this.$emit('update:data', { ...this.data, [`${traitType}`]: data });
    },
    resetAllFilter() {
      const newData = {};
      if (this.$refs) {
        for (const key in this.$refs) {
          if (this.data[`${key}`] || this.data[`${key}`] === 0) {
            this.clearProperty(key);
            newData[`${key}`] = '';
          }
        }
      }
      this.$emit('update:data', { ...this.data, ...newData });
    },
    handleSearchRange(traitType, minValue, maxValue) {
      this.$emit('update:data', {
        ...this.data,
        [`${traitType}`]: { min: minValue, max: maxValue }
      });
    },
    clearProperty(traitType) {
      if (!this.data[`${traitType}`] && this.data[`${traitType}`] !== 0) return;
      this.$refs[`${traitType}`][0].resetValue();
      this.$emit('update:data', {
        ...this.data,
        [`${traitType}`]: ''
      });
    }
  }
};
</script>
